// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"19782":"998209edfa998034","26654":"a5937532ba4fca98"}[chunkId] + ".css";
};